// src/lib/opportunity/formTemplateContactClient.ts

import { opportunityFetch } from "./opportunityFetch.js";
import type { FormTemplateContact } from "./formContactTypes.js";

export function getFormTemplateContact(formTemplateId: string) {
  const q = new URLSearchParams({ form_template_id: formTemplateId });
  return opportunityFetch<{ ok: true; contact: FormTemplateContact | null }>(
    `/api/opportunity/form-template-contact-get?${q.toString()}`,
    { method: "GET" },
  );
}

export type UpsertFormTemplateContactPayload = {
  form_template_id: string;
  org_name: string | null;
  person_name: string | null;
  address: string | null;
  phone: string | null;
  email: string | null;
};

export function upsertFormTemplateContact(payload: UpsertFormTemplateContactPayload) {
  return opportunityFetch<{ ok: true; contact: FormTemplateContact }>(
    "/api/opportunity/form-template-contact-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}
